import { Api } from "@/networking";
import {
  LoginFormType,
  ResponseLoginType,
  ResponseResetPasswordType,
} from "@/types";

export const loginAPI = (data: LoginFormType) => {
  return Api.LOGIN<ResponseLoginType>("", {
    data,
  });
};

export const resetPasswordAPI = (email: string) => {
  return Api.RESET_PASSWORD<ResponseResetPasswordType>("", {
    data: { email },
  });
};
